// removed by extract-text-webpack-plugin
module.exports = {"table_ui":"_1BtjF","table_add":"_3WJ4h","table_delete":"_3TFpv","button":"_2Riok","btn_primary":"_3LVyI _2Riok","btn_secondary":"HiXgK _2Riok","btn_warning":"_3EESO HiXgK _2Riok","root":"_3E6JP","headline":"_2yPpN","headline__btn":"_1NcOd HiXgK _2Riok","headline__icon":"YuOGG","cell":"_8VINP","table":"_3obor _1BtjF","delete":"_1fo97 _3TFpv"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/templates/Templates.css
// module id = 915
// module chunks = 0